export default __webpack_public_path__ + "static/media/calendar_icon.417fe0ca.svg";